import moment from 'moment';
import "moment-timezone";
import { Constants } from '../shared/models/constants';


export class DateHandler {



  // See the Moment.js docs for the meaning of these formats:
  // https://momentjs.com/docs/#/displaying/format/
  public static DATE_PICKER_FORMAT = {
    display: {
      dateInput: 'DD-MMM-YYYY',
      monthYearLabel: 'MMM YYYY',
      dateA11yLabel: 'L',
      monthYearA11yLabel: 'MMMM YYYY',
    },
  };

  convertUTCDateToCST(dateStr: string) {
    const date: Date = this.getDateTime(dateStr);
    const offset = date.getTimezoneOffset() / 60;
    const hours = date.getHours();
    date.setHours(hours - offset);
    return date;
  }

  convertToCentralTimeISOFormat(date:any): string{
    return moment(date)
    .subtract(moment(date)
    .tz(Constants.CST_TIMEZONE).utcOffset() / 60, "hours")
    .format(Constants.DATE_TIME_ISO_FMT);
  }
  convertLocalTimeToUTCISOFormat(date:Date) :any{
   return moment.utc(date).local().format(Constants.DATE_TIME_ISO_FMT);
  }
  private getDateTime(date: string): Date {
    return new Date(date);
  }

  getUTCNow() {

    const now = new Date();
    const str =
      ("0" + (now.getUTCMonth() + 1)).slice(-2) +
      "/" +
      now.getUTCDate() +
      "/" +
      ("0" + now.getUTCFullYear().toString()).slice(1) +
      " " +
      "0" + (now.getUTCHours() > 12 ? now.getUTCHours() - 12 : now.getUTCHours()).toString().slice(-2) +
      ":" +
      now.getUTCMinutes() +
      " " +
      (now.getUTCHours() > 12 ? "PM" : "AM");

    return str;
  }

  addZeroBefore(num: number): string {
    return num < 10 ? '0' + num.toString() : num.toString();
  }

  getCurrentISOUtcDateTime() {
    const currentLocalDate = new Date();

    return moment.utc(
      currentLocalDate.getUTCFullYear().toString() +
      "-" +
      this.addZeroBefore(currentLocalDate.getUTCMonth() + 1) +
      "-" +
      this.addZeroBefore(currentLocalDate.getUTCDate()) +
      "T" +
      this.addZeroBefore(currentLocalDate.getUTCHours()) +
      ":" +
      this.addZeroBefore(currentLocalDate.getUTCMinutes())
    );
  }
  getHoursMinutes(totalMinutes: number): string {
    var hour = Math.floor(totalMinutes / 60);
    var mins = totalMinutes - (hour * 60);
    var minutes = mins.toLocaleString().length === 1 ? "0" + mins : mins;
    return hour + " : " + minutes;
  }
}
